export const MAX_RECORDS_QUERY = {
    page: 0,
    itemsPerPage: 1000,
}

export const DEFAULT_ROWS_PER_PAGE = 15
